import { Dialog, DialogContent } from '@mui/material';

import { Button } from 'react-bootstrap';
import { Dispatch, SetStateAction } from 'react';

import { IUserFromStorage } from '../../../Interfaces/IUser';

interface Props {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  sendData: () => void;
}

function ModalConfirmarControl({ isOpen, setIsOpen, sendData }: Props) {

  const user: IUserFromStorage = JSON.parse(localStorage.getItem('user'));

  return (
    <Dialog open={isOpen} onClose={() => setIsOpen(false)}>
      <DialogContent className="flex flex-col gap-2 justify-center items-center">
        <h4 className="mb-4 text-center">¿Los datos que ingresaste son correctos?</h4>
        <div className="flex items-center justify-center gap-4">
          <Button
            onClick={() => {
              sendData();
              setIsOpen(false);
            }}
            variant="contained"
            className="p-2 px-4 rounded-lg"
            style={{ backgroundColor: '#FF8E01', color: 'white' }}
          >
            Sí
          </Button>
          <Button
            onClick={() => setIsOpen(false)}
            variant="contained"
            className="bg-black p-2 px-4 rounded-lg text-white"
          >
            No
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default ModalConfirmarControl;